export const LANGUAGES = [
  'Albanian', 'Arabic', 'Bulgarian', 'Catalan', 'Chinese (Mandarin)', 'Croatian', 'Czech',
  'Danish', 'Dutch', 'English', 'Estonian', 'Finnish', 'French', 'German',
  'Greek', 'Hebrew', 'Hindi', 'Hungarian', 'Indonesian', 'Italian', 'Japanese', 'Korean',
  'Latvian', 'Lithuanian', 'Norwegian', 'Polish', 'Portuguese', 'Romanian',
  'Russian', 'Serbian', 'Slovak', 'Slovenian', 'Spanish', 'Swedish', 'Thai',
  'Turkish', 'Ukrainian', 'Vietnamese',
] as const;
